module.exports = {"id":"146947","name":"Vesga","rating":"73","photo":"./data/images/photos/4/146947.png","club":{"name":"Athletic Bilbao","logo":"./data/images/clubs/AthleticBilbao.png"},"positions":["MDC","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Vesga0.json
// module id = 4243
// module chunks = 0